import React from 'react';
import { type BookService } from '@fiverr-private/book_publishing_types';
import { AppI18n, appTranslate } from '../../../../i18n';

interface HighlightsData {
    bpService?: BookService;
}

export interface AlsoOffersBPServicesProps {
    highlightsData?: HighlightsData;
}

export const AlsoOffersBPServices: React.FC<AlsoOffersBPServicesProps> = ({ highlightsData = {} }) => {
    const { bpService } = highlightsData;

    if (!bpService) return null;

    return (
        <AppI18n k="highlights.also_offers" params={{ service: appTranslate(`highlights.bp_services.${bpService}`) }} />
    );
};
